import { useMemo, ReactElement, ReactNode } from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Icon } from '../../../icon/Icon.component';
import { Heading, type HeadingProps } from '../../heading/heading.component';
import { useStepperCardContext } from '../provider/stepper-card.provider';
import { useStepperContext } from '../provider/stepper.provider';

export type StepperTitleProps = {
  showChildrenOnCompleted?: boolean;
  icon?: ReactElement;
  level?: HeadingProps['level'];
  children: ReactNode;
  className?: string;
};

const titleContainerStyle = css`
  display: flex;
  align-items: center;
`;

const iconStyle = css`
  margin-right: ${theme.spacing(1)};
  height: ${theme.spacing(3)};
`;

const headingStyle = css`
  margin: ${theme.spacing(0)};
  text-transform: capitalize;
  flex-grow: 1;
`;

export const StepperTitle = ({
  showChildrenOnCompleted,
  icon,
  children,
  level = 2,
  className,
  ...rest
}: Partial<StepperTitleProps>) => {
  const { stepStatus } = useStepperContext();
  const { step, stepValue } = useStepperCardContext();

  const titleDisplay = useMemo(() => {
    if (step)
      if (!showChildrenOnCompleted && stepStatus[step] === 'completed' && stepValue) {
        return stepValue;
      }
    return children;
  }, [stepStatus[step], stepValue]);

  return (
    <div {...rest} className={cx('step-title-container', titleContainerStyle, className)}>
      {icon && <Icon className={cx('step-content-svg', iconStyle)}>{icon}</Icon>}
      <Heading level={level} className={cx('step-content-title', headingStyle)}>
        {titleDisplay}
      </Heading>
    </div>
  );
};
